import { render, staticRenderFns } from "./browser_compat_box.vue?vue&type=template&id=7124bdcf&scoped=true&"
import script from "./browser_compat_box.vue?vue&type=script&lang=js&"
export * from "./browser_compat_box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7124bdcf",
  null
  
)

export default component.exports